import { getFirestore, initializeFirestore } from "firebase/firestore";
import { app } from "./firebase";
import { IS_CHINA_MODE } from "./chinaMode";

// V120: 중국 모드(jjggfood.com)는 중계 서버를 거치므로 실시간 연결을 long-polling으로 고정한다 (중계에 가장 무난한 방식)
// V148: 한 번 기다리는 시간을 20초로 짧게 — 중국 망에서 오래 열려 있는 연결이 중간에 끊기는 경우를 줄인다
export const db = IS_CHINA_MODE
  ? initializeFirestore(app, { experimentalForceLongPolling: true, experimentalLongPollingOptions: { timeoutSeconds: 20 } })
  : getFirestore(app);
